import { useEffect, useState } from "react";
import axios from "axios";
import { ACCESS_KEY } from "../config";
function LiveBan() {

  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState("4 Hours");
  const [showBanModal, setShowBanModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showUnbanModal, setShowUnbanModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 20;

  useEffect(() => {
  getLiveBanUsers();
}, []);

const getLiveBanUsers = async () => {
  try {
    const response = await axios.get(
      "https://admin.butterlive.co.in/management/live-ban-users",
      {
        headers: {
          key: ACCESS_KEY,
        },
      }
    );

    setUsers(response.data.data);
  } catch (error) {
    console.log(error);
  }
};



const videoLiveBan = async (user) => {
let url =
  "https://admin.butterlive.co.in/management/video-live-ban";

if (!user.enableToLive) {
  url =
    "https://admin.butterlive.co.in/management/video-live-unban";
}
  try {
    const duration = selectedDuration;
    const response = await axios.post(
  url,
      {
        userId: user.userId,
        duration,
      },
      {
        headers: {
          key: ACCESS_KEY,
        },
      }
    );

    //alert(response.data.message);

    getLiveBanUsers();
  } catch (error) {
    console.log(error);
    alert("Video Ban Failed");
  }
};


const filteredUsers = users.filter((user) =>
  (user.name || "")
    .toLowerCase()
    .includes(search.toLowerCase()) ||
  String(user.uniqueId || "").includes(search)
);
const indexOfLastUser = currentPage * usersPerPage;

const indexOfFirstUser =
  indexOfLastUser - usersPerPage;

const currentUsers = filteredUsers.slice(
  indexOfFirstUser,
  indexOfLastUser
);

const totalPages = Math.ceil(
  filteredUsers.length / usersPerPage
);


  return (
    <div>
      <div className="page-header">
  <h1 className="page-title">
    Live Ban Management
  </h1>
</div>

<div className="top-bar">
<input
  type="text"
  placeholder="Search Name / User ID"
  className="search-box"
  value={search}
  onChange={(e) => setSearch(e.target.value)}
/>
</div>

<div className="table-card">
<table
  width="100%"
  cellPadding="12"
  style={{ minWidth: "1400px" }}
>
        <thead>
          <tr>
            <th>Sr No</th>
            <th>Photo</th>
            <th>Name</th>
            <th>User ID</th>
            <th>Coins</th>
            <th>Diamonds</th>
            <th>Country</th>
            <th>Level</th>
            <th>Ban Count</th>
            <th>Duration</th>
            <th>Status</th>
            <th>Action</th>
            <th>A-Status</th>
            <th>A-Action</th>
          </tr>
        </thead>

        <tbody>
          {currentUsers.map((user, index) => (
            <tr key={user.id}>
              <td>{indexOfFirstUser + index + 1}</td>

                <td>
                  {user.image ? (
                    <img
                      src={user.image}
                      alt=""
                      className="user-avatar"
                    />
                  ) : (
                    "—"
                  )}
                </td>

              <td>{user.name}</td>
              <td>{user.uniqueId}</td>
              <td>{user.coins}</td>
              <td>{user.diamonds}</td>
              <td>{user.country}</td>
              <td>{user.level}</td>
              <td>{user.liveBanCount || 0}</td>
              <td>{user.liveBanDuration || "-"}</td>

<td>
  <span
    className={
      user.enableToLive
        ? "status-active"
        : "status-banned"
    }
  >
    {user.enableToLive ? "Active" : "Banned"}
  </span>
</td>


<td>
<button
  onClick={() => {
  if (user.enableToLive) {
    setSelectedUser(user);
    setShowBanModal(true);
  } else {
    setShowUnbanModal(true);
    setSelectedUser(user);
  }
}}
  className={
    user.enableToLive
      ? "ban-btn ban-btn-active"
      : "ban-btn ban-btn-unban"
  }
>
  {user.enableToLive
    ? "Live Ban"
    : "Unban"}
</button>
</td>


<td>
  <span
    className={
      user.audioStatus === "Banned"
        ? "status-banned"
        : "status-active"
    }
  >
    {user.audioStatus}
  </span>
</td>
<td>
  <button
    className={
      user.audioStatus === "Banned"
        ? "ban-btn ban-btn-unban"
        : "ban-btn ban-btn-active"
    }
  >
    {user.audioStatus === "Banned"
      ? "A-Unban"
      : "A-Ban"}
  </button>
</td>

            </tr>
          ))}
        </tbody>
      </table>


<div className="pagination">

<button
  disabled={currentPage === 1}
  onClick={() =>
    setCurrentPage(currentPage - 1)
  }
>
  Previous
</button>

<span>
  Page {currentPage} of {totalPages}
</span>

<button
  disabled={currentPage === totalPages}
  onClick={() =>
    setCurrentPage(currentPage + 1)
  }
>
  Next
</button>

</div>

</div>


{showBanModal && (
  <div className="modal-overlay">
    <div className="modal-box">

      <h3>Select Duration</h3>

      <select
        value={selectedDuration}
        onChange={(e) =>
          setSelectedDuration(e.target.value)
        }
      >
        <option>4 Hours</option>
        <option>8 Hours</option>
        <option>1 Day</option>
        <option>7 Days</option>
        <option>Permanent</option>
      </select>

      <br />
      <br />

      <button
        onClick={() => setShowBanModal(false)}
      >
        Cancel
      </button>

<br />
<br/>
<button
  className="ban-btn ban-btn-active"
  onClick={() => {
    videoLiveBan(selectedUser);
    setShowBanModal(false);
  }}
>
  Confirm Ban
</button>
    </div>
  </div>
)}



{showUnbanModal && (
  <div className="modal-overlay">
    <div className="modal-box">

      <h3>Confirm Unban</h3>

      <p>
        Are you sure you want to unban this user?
      </p>

      <button
        onClick={() => setShowUnbanModal(false)}
      >
        Cancel
      </button>

<br />
<br />

<button
  className="ban-btn ban-btn-unban"
  onClick={() => {
    videoLiveBan(selectedUser);
    setShowUnbanModal(false);
  }}
>
  Confirm Unban
</button>
    </div>
  </div>
)}

   </div>
  );
}

export default LiveBan;
